<template>
  <div class="card-main vx-card card-bk" :style="getThumbPathStyle" @click.stop="openDetail(data)">
    <div class="info-post">
      <span class="important sub-title" v-if="data.exclusive">{{ $t('BADGES').Exclusive }}</span>
      <div class="sub-title" v-if="!displayHatField" :class="{ 'important': isImportant(data) }">{{
        getSubjectName(data.subjects) }}
      </div>
      <div class="sub-title" v-if="displayHatField" :class="{ 'important': isImportant(data) }">{{ hatName }}</div>
      <h6 class="title" style="margin-bottom: 0px"> {{ getTitle }} <span class="author" @click.stop="$emit('open-author', data.author)"> — {{
        $t('VIEW_MODES').By }}
          {{ data.author.nickname ? data.author.nickname : data.author.name }}</span></h6>

      <div class="footer-cards mb-1">
        <div class="card-date" v-if="canDisplayDateField">
        <template v-if="!isAuthenticated">
            <div class="item-date" v-if="!isReport">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</div>
            <div class="item-date" v-if="isReport">{{ formatFullDate(data.dt_report, { dateStyle: "short" }) }}</div>
          </template>
          <template v-else>
            <span class="item-date" v-if="!isReport">{{ formatDate(data.dt_publish, { dateStyle: "short" }) }}</span>
            <span class="item-date" v-if="isReport">{{ formatFullDate(data.dt_report, { dateStyle: "short" }) }}</span>
          </template>
        </div>
        <div class="icons-cardsinformative icons-informative">
          <action-icons-field :data="data" :isAuthenticated="isAuthenticated" :isDesktop="isDesktop"
            @addPlaylist="addPlaylist" @playMultimedia="playMultimedia" @onDownloadFile="onDownloadDocument"
            @open-exclusive-content="$emit('open-exclusive-content')" @save-schedule-news="$emit('save-schedule-news', data)">
          </action-icons-field>
        </div>
      </div>
    </div>
    <div class="badge live" v-if="data.inLive" @click.stop="onFilter('inLive', true)">
      <div class="badge-wrap">
        <span class="badge-icon badge-view">
          <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z">
            </path>
          </svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14">
              <path
                d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z">
              </path>
            </svg>
          </span>
        </span>
        <span class="badge-text">{{ $t('BADGES').InLive }}</span>
      </div>
    </div>
    <div class="badge bdg-imp" v-if="isImportant(data) && !data.inLive" @click.stop="onFilter('important', true)">
      <div class="badge-wrap"> <span class="badge-text">{{ $t('BADGES').Important }}</span></div>
    </div>
    <div class="badge" v-if="data.exclusive">
      <div class="badge-wrap" @click.stop="onFilter('exclusive', true)"> <span class="badge-text">{{
        $t('BADGES').Exclusive }}</span></div>
    </div>
    <div class="badge disclosure-announcement-badge" v-if="isDisclosureAnnouncement"
      @click.stop="onFilter('disclosureAnnouncement', true)">
      <div class="badge-wrap"> <span class="badge-text">{{ $t("BADGES").Announcement }}</span></div>
    </div>
    <div class="badge disclosure-invite-badge" v-if="isDisclosureInvite" @click.stop="onFilter('disclosureInvite', true)">
      <div class="badge-wrap"> <span class="badge-text">{{ $t("BADGES").Invite }}</span></div>
    </div>
  </div>
</template>

<script>
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import { CONTENT } from "../../../enums/enum-content";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import generalHelper from '../../../helpers/general-helper';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import InformativePreviewData from './InformativePreviewData.vue';
import formatFieldHelper from '../../../helpers/format-field-helper';
import AppConstants from '../../../appConstants';
import ActionIconsField from '../../../layouts/components/customizer/ActionIconsField.vue';
import convertDatetimeHelper from "../../../helpers/convert-datetime-helper";
// import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    contentId: {
      require: true,
    },
    currentCommodity: {
      require: true,
    },
    isAuthenticated: {
      require: true
    },
  },
  data() {
    let dSize;
    if (this.isDesktop) {
      dSize = "20px";
    } else {
      dSize = "30px";
    }
    return {
      dropdownSize: dSize,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      thumbPath: '',
    };
  },
  watch: {},
  computed: {
    canDisplayDateField() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code != CONTENT.CONSULTING_COURSES
        ) >= 0
      );
    },
    isReport() {
      return (
        this.data.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    isDisclosureInvite() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE;
    },
    isDisclosureAnnouncement() {
      return this.data.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT;
    },
    getTitle() {
      if (!this.data) return '';
      if (this.data.newsContent[0].code == CONTENT.STATISTIC ||
        this.data.newsContent[0].code == CONTENT.EXPORTS ||
        this.data.newsContent[0].code == CONTENT.INFORMATIVE) {
        return translateFieldHelper.getTranslateField('name', this.data.reportType);
      }
      return this.data.content.title.data;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    headerStyle() {
      try {
        let commodityFile = '';
        let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
        if (this.currentCommodity.id && this.currentCommodity.id > 0) {
          // commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
          commodityFile = require(`@/assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
        } else {
          // commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.data.subjects[0].code}.png`);
          commodityFile = require(`@/assets/images/commodity/${originCode}/${this.data.subjects[0].code}.png`);
        }
        return `background-image: url("${commodityFile}");`;
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    canDisplayPreview() {
      return (this.data.content.abstract || this.data.content.text) && this.isDesktop;
      // return (
      //   this.data.newsContent[0].code == CONTENT.NEWS ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_TV ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_PODCAST ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING_COURSES ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING_SPEECHES ||
      //   this.data.newsContent[0].code == CONTENT.CONSULTING_EXCHANGE ||
      //   this.data.newsContent[0].code == CONTENT.WEATHER
      // );
    },
    detailContent() {
      if (this.data.content.body) {
        return this.linkify(this.data.content.body.data);
      }
      return "";
    },
    hatName() {
      if (this.data.hat[0]) {
        return this.data.hat[0].name.toUpperCase();
      }
      return this.data.newsContent[0][`name${this.$i18n.locale}`];
    },
    displayReportDate() {
      return (
        this.data.newsContent[0].code != CONTENT.CONSULTING_COURSES &&
        this.data.newsContent[0].code != CONTENT.CONSULTING_SPEECHES
      );
    },
    hasPeriodicity() {
      if (!this.data.periodicity) return false;
      return !!this.data.periodicity.name;
    },
    hasCharacteristic() {
      if (!this.data.characteristic) return false;
      return !!this.data.characteristic.name;
    },
    hasMultimedia() {
      return (
        !!this.data.soundcloud ||
        !!this.data.youtubeId ||
        !!this.data.audio ||
        !!this.data.spotify
      );
    },
    hasDocument() {
      return !!this.data.document;
    },
    displayHatField() {
      return (
        this.data.newsContent[0].code == CONTENT.NEWS ||
        this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_TV ||
        this.data.newsContent[0].code == CONTENT.CONSULTING_SAFRAS_PODCAST
      );
      // return (
      //   this.contentId == CONTENT.NEWS ||
      //   this.contentId == CONTENT.CONSULTING_SAFRAS_TV ||
      //   this.contentId == CONTENT.CONSULTING_SAFRAS_PODCAST
      // );
    },
    isItemNews() {
      return this.data.newsContent[0].code == CONTENT.NEWS;
    },
    hasTextToSpeech() {
      if ((this.data.content.abstract || this.data.content.text) && !this.hasDocument && this.isDesktop) {
        return `${this.getTitle} ${this.data.content.abstract.data} ${this.data.content.text.data}`;
      }
      return false;
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.data, this.isDesktop);
    },
    canAddPlaylist() {
      return (
        !!this.data.youtubeId ||
        !!this.data.audio ||
        !!this.data.soundcloud ||
        !!this.data.spotify
      ) && this.isAuthenticated;
    },
    badgeTypeClass() {
      if (this.data.document) return "attach-document";
      if (this.data.audio) return "audio";
      if (this.data.youtubeId) return "video";
      if (this.data.soundcloud) return "podcast";
      if (this.data.spotify) return "podcast";
      return "";
    },
    getThumbPathStyle() {
      if (this.thumbPath) {
        return `background-image:url('${this.thumbPath}')`;
      }
      return this.headerStyle;
    }
  },
  methods: {
    onFilter(field, val) {
      this.$emit("filter", { field: field, value: val });
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    async getThumbPath() {
      // this.thumbPath = require("@/assets/images/informative/placeholder115.svg");
      if (this.data && this.data.thumb) {
        const exist = await generalHelper.checkImageExist(this.data.thumb.image_path);
        if (exist) {
          this.thumbPath = this.data.thumb.image_path;
        }
      }
    },
    onDownloadDocument(data) {
      this.$emit("onDownloadFile", data);
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
    },
    getSubjectIcon(subjects) {
      if (this.currentCommodity.id) {
        const sub = subjects.find(
          (item) => item.code == this.currentCommodity.id
        );
        if (sub) {
          return sub.icon;
        }
      }
      return subjects[0].icon;
    },
    playMultimedia({ data, isTextSpeech }) {
      this.$emit("playMultimedia", {
        data: data,
        isTextSpeech: isTextSpeech,
      });
    },
    featherIconSize() {
      if (this.isDesktop) {
        return "h-4 w-4 icon-safra";
      } else {
        return "h-6 w-6 icon-safra";
      }
    },
    getIconCard(reportDetail) {
      if (this.hasYoutube(reportDetail)) {
        return "VideoIcon";
      } else if (
        this.hasAudio(reportDetail) ||
        this.hasSoundCloud(reportDetail) ||
        this.hasSpotify(reportDetail)
      ) {
        return "MicIcon";
      } else if (this.hasDocument) {
        return "PaperclipIcon";
      } else {
        return null;
      }
    },
    hasAudio(reportDetail) {
      return !!reportDetail.audio;
    },
    hasYoutube(reportDetail) {
      return !!reportDetail.youtubeId;
    },
    hasSpotify(reportDetail) {
      return !!reportDetail.spotify;
    },
    hasSoundCloud(reportDetail) {
      return !!reportDetail.soundcloud;
    },
    hasImageOrThumbUrl(reportDetail) {
      return !!reportDetail.image || !!reportDetail.thumb;
    },
    isImportant(value) {
      return value.importance > 0;
    },
    addPlaylist(reportDetail) {
      // alert(`add playlist: ${reportDetail._id}`);
      // console.log(`add playlist: ${reportDetail._id}`);
      this.$store.dispatch("insertItemPlaylist", reportDetail);
    },
    openDetail(reportDetail) {
      this.$emit("openDetailParent", reportDetail);
    },
    imageUrl(value) {
      if (value.thumb) {
        return value.thumb.image_path;
      }
      if (value.image) {
        return value.image.image_path;
      }

      return require("@/assets/images/informative/placeholder115.svg");
    },
  },
  async created() {
    await this.getThumbPath();
  },
  components: {
    popper: Popper,
    DropdownUserInfo,
    InformativePreviewData,
    ActionIconsField,
    // VuePerfectScrollbar
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  body {
    background-color: lightblue;
  }
}

@media only screen and (max-width: 600px) {
  .content-field {
    white-space: pre-line;
    height: auto;
    margin: 0 !important;

    img {
      transition: 0.35s;
      margin-top: 5px;
      margin-bottom: 10px;
      width: 100%;
      height: 115px;
      object-fit: cover;
      object-position: 0 50%;
    }
  }
}

@media (min-width: 600px) {
  .content-field {
    white-space: pre-line;
    height: auto;
    margin: 0 !important;

    .filter-chip {
      font-weight: 400;
      font-size: 8px;

      height: 14px;
      min-height: 0;
      align-items: center;
    }

    .item-date {
      margin-bottom: 2px;
      font-size: 10px !important;
      margin-top: 0 !important;
    }

    .card-text-title {
      // font-size: 11px;
    }

    .card-text-commodity {
      text-transform: none !important;
      font-size: 12px;
    }

    img {
      transition: 0.35s;
      margin-top: 5px;
      margin-bottom: 10px;
      width: 100%;
      height: 115px;
      object-fit: cover;
      object-position: 0 50%;
    }
  }
}

.card-title {
  font-size: 12px;
  font-weight: 600;
  line-height: px;
  height: 34px;
  display: table-cell;
  vertical-align: middle;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.card-text-commodity {
  text-transform: none !important;
}

.theme-dark .custom-item .badge-text {
  color: #FFF !important;
}

.card-main {
  border-radius: 0;
  background-color: #fff;
  border: 1px solid #d6d6d6;
  cursor: pointer;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 335px;
}

.card-main:hover {
  background-color: #efefef !important;
  transform: translateY(-5px);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.3);
}

.card-date {
  background-color: #000;
  color: #FFF !important;
  height: 23px;
    line-height: 20px;

  .item-date {
    margin-left: 5px;
    color: #fff !important;
  }
}

.card-date {
  background-color: #000;

  .item-date {
    margin-left: 4px;
    color: #FFF !important;

  }
}

.theme-dark .card-main:hover {
  box-shadow: 0 4px 25px 0 rgba(120, 120, 120, 0.2);
}

.theme-dark .card-main {
  border-radius: 0;
  background-color: #353e45;
  border: 1px solid #4d5762;
  cursor: pointer;
}

.theme-dark .card-main:hover {
  background-color: #4d5762 !important;
}

.item-avatar {
  margin-top: -6px;
  /*position: absolute;*/
  /*margin-left: 10px;*/
  float: left;
}

.card-chips {
  // min-width: 150px;
  margin-top: 2px;
  display: flex;
}

.item-date {
  margin-bottom: 2px;
  margin-top: 0 !important;
}

.item-card-chapeu {
  color: #ababab;
  font-size: 10px;
  margin-top: 2px;
  font-weight: 500;
  text-align: right;
}

.badge {
  display: inline-block;
  padding: 2px 6px;
  color: #fff;
  background: #e41505;
  border-radius: 4px;
  float: right;
  margin-top: 5px;
  margin-right: 5px;
}

.badge-wrap {
  display: flex;
  align-items: center;
}

.badge-icon {
  position: relative;
  display: inline-flex;
  margin-right: 2px;
}

.badge-icon-inner {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;
  -webkit-animation: ani-breath 1.8s ease infinite;
  animation: ani-breath 1.8s ease infinite;
}

.badge-icon svg {
  fill: currentColor;
}

.badge-text {
  display: inline-flex;
  font-size: 10px;
  line-height: 14px;
  text-transform: uppercase;
}

@-webkit-keyframes ani-breath {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}

@keyframes ani-breath {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}
</style>
